import moment from 'moment';
import { React, PT, fetchApi } from '@gasbuddy/react';
import { Modal, Button, Dimmer, Loader, Checkbox, Message } from 'semantic-ui-react';

export function TerminateMembershipModal({ accountId, onUpdate, provisioned, endDate, scheduledExpiryDate }) {
  const [open, setOpen] = React.useState();
  const [loading, setLoading] = React.useState();
  const [immediate, setImmediate] = React.useState(!!scheduledExpiryDate);
  const [error, setError] = React.useState();

  const terminate = React.useCallback(async () => {
    await Promise.all([setLoading(true), setError(false)]);
    const { status, body } = await fetchApi({
      url: `/payments/programs/${accountId}/membership/terminate`,
      body: { immediate },
    }).catch(e => ({ status: e.status, body: e }));
    await setLoading(false);
    // TODO: It returns undefined status for 204 response. Consider it a success for now and look into why
    if (!status || [204, 202].includes(status)) {
      onUpdate();
      setOpen(false);
    } else {
      setError(body);
    }
  }, [immediate]);

  return (
    <Modal
      open={open}
      trigger={(
        <Button negative onClick={() => setOpen(true)}>
          Terminate
          {scheduledExpiryDate && ' Now'}
        </Button>
      )}
    >
      <Modal.Header>Terminate Membership</Modal.Header>
      <Modal.Content>
        <Dimmer.Dimmable dimmed={loading}>
          {error && (
            <Message negative>
              <Message.Header>Oops - Changes Failed</Message.Header>
              <pre>{`${JSON.stringify(error)}`}</pre>
            </Message>
          )}
          <Dimmer active={loading}>
            <Loader />
          </Dimmer>
          <div>
            { provisioned && !scheduledExpiryDate
              ? (
                <div>
                  Are you sure you want to schedule the membership benefits to auto terminate on:
                  {` ${moment(endDate).format('MMM Do YYYY')}`}
                  ?
                  <div style={{ margin: '20px 0' }}>
                    <Checkbox
                      style={{ marginLeft: 20 }}
                      checked={immediate}
                      onChange={() => setImmediate(!immediate)}
                      label="Terminate immediately instead"
                    />
                  </div>
                </div>
              )
              : <div>Are you sure you want to immediately terminate the membership benefits?</div>
            }
          </div>
        </Dimmer.Dimmable>
      </Modal.Content>
      <Modal.Actions>
        {!loading && <Button basic onClick={() => setOpen(false)}>No</Button>}
        <Button primary loading={loading} onClick={terminate}>
          Yes
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

TerminateMembershipModal.propTypes = {
  accountId: PT.number,
  onUpdate: PT.func.isRequired,
  provisioned: PT.bool.isRequired,
  endDate: PT.string.isRequired,
  scheduledExpiryDate: PT.string.isRequired,
};

TerminateMembershipModal.defaultProps = {
  accountId: 0,
};
